<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog
    title="新增渠道类目"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="类目名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
    
    
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading"
        >确 定</el-button
      >
    </div>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </el-dialog>
</template>

<script>
import materialApi from "@/api/material.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      filePath:'',
      form: {
        cate_id: "",
        name: "",
        sort: 100,
        material_stock: "",
        material_price: "",
        sales_actual: 0,
        // imageId: "",
        radio: 1,
        radio1: 1,
        catList: [
          {
            name: "浙江",
            cate_id: 1,
          },
          { name: "上海", cate_id: 2 },
          { name: "北京", cate_id: 3 },
        ],
      },
      formRules: {
        name: [
          {
            required: true,
            message: "请输入物料名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "物料排序不能为空",
          },
          {
            type: "number",
            message: "物料排序必须为数字",
          },
        ],
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
    };
  },
  props: ["open_add", "addform"],
  created() {
    console.log(this.addform);
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加物料*/
    addUser() {
      let self = this;
      let params = self.form;
      console.log(params);
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          materialApi
            .addProduct(params)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: "添加成功",
                type: "success",
              });
              self.dialogFormVisible(true);
            })
            .catch((error) => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false,
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath;
        this.form.imageId = e[0].fileId;
      }
      this.isupload = false;
    },
  },
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/channel/category/cashrewords/Add.vue